import type { ProjectSkillsPrediction } from './project-skills-prediction.model';
import { defaultPredictedSkills } from '../skills/skills.seed';

export interface GeneratePredictedSkillsLlmOptions {
  readonly title: string;
  readonly description: string;
  readonly tags?: readonly number[];
  readonly suggested?: readonly number[];
}

export function generateProjectSkillsPredictionObject({
  title,
  description,
  tags = defaultPredictedSkills.map(skill => skill.id).slice(0, 2),
  suggested = defaultPredictedSkills.map(skill => skill.id).slice(2, 5),
}: GeneratePredictedSkillsLlmOptions): ProjectSkillsPrediction {
  return {
    id: `${title}-${description}`,
    title,
    description,
    tags,
    suggested,
  };
}
